import { useEffect, useRef } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { BsXCircle } from 'react-icons/bs';

import Card from '#globalComponents/Card/Card';
import Page from '#globalComponents/Page/Page';
import FullscreenLayout from '#layouts/FullscreenLayout';

import { useAbandonPostMailingPayment } from '../../models/campaigns/mutations';

/**
 * Landing page after the customer cancels/abandons the Stripe Checkout for a post-mailing payment. Resets
 * the campaign back to draft (so it can be edited/retried), then forwards to the campaign detail page.
 */
export const PostMailingCheckoutCancelPage = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const campaignId = searchParams.get('campaignId');
	const abandonPayment = useAbandonPostMailingPayment();
	const ranRef = useRef(false);

	useEffect(() => {
		if (ranRef.current) return;
		ranRef.current = true;

		const finish = () => navigate(campaignId ? `/post-mailing/${campaignId}` : '/post-mailing', { replace: true });
		if (!campaignId) {
			finish();
			return;
		}
		// Reset the campaign to draft, then forward regardless of outcome (idempotent backend call).
		abandonPayment.mutate(campaignId, { onSettled: () => setTimeout(finish, 1500) });
	}, [campaignId, navigate, abandonPayment]);

	return (
		<Page>
			<FullscreenLayout>
				<Card className="p-12 text-center">
					<div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-bgBase-400">
						<BsXCircle size={48} className="text-bgBase-800" />
					</div>
					<h1 className="mb-3 text-lg font-bold text-text">Zahlung abgebrochen</h1>
					<p className="text-text">
						Es wurde nichts berechnet. Sie können die Kampagne weiter bearbeiten und den Versand erneut
						starten.
					</p>
				</Card>
			</FullscreenLayout>
		</Page>
	);
};
